//#region Old Code
// import React from 'react';
// import request from 'arcdynamic-request';
// import Dropdown from "../Dropdown/Dropdown";
// import PropTypes from "prop-types";

// class SelectTeam extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             items: [],
//         };
//     }

//     componentDidMount() {
//         request(arc.path.api, {
//             service: 'arcimedes',
//             action: 'open.datasource.table.Data.getData',
//             params: ['code', 'TEAM', {
//                 limit: {
//                     count: 1000,
//                     offset: 0,
//                 },
//                 column: [
//                     'ARCIMEDES_ROW_ID',
//                     'FIRST_NAME',
//                     'LAST_NAME',
//                     'DELETED',
//                     'IS_AGENT',
//                 ],
//                 filter: [
//                     {
//                         code: 'FIRST_NAME',
//                         text: '',
//                         type: 'notNull',
//                     },
//                     {
//                         code: 'LAST_NAME',
//                         text: '',
//                         type: 'notNull',
//                     },
//                 ],
//                 filterType: 'and',
//                 order: [
//                     {
//                         code: 'FIRST_NAME',
//                         type: 'asc',
//                     },
//                     {
//                         code: 'LAST_NAME',
//                         type: 'asc',
//                     },
//                 ],
//             }],
//         }).then(res => {
//             let items = res.data ? res.data.filter(x => x.FIRST_NAME && x.LAST_NAME) : false;           
//             this.setState({items});
//         });
//     }

//     render() {
//         const {
//             theme,
//             value,
//             valueKey,
//             percentKey,
//             label,
//             percentLabel,
//             disabled,
//             data,
//             isFilter,
//             handleParentChange,
//             handleInputParentChange,
//             viewMode,
//             deleted,
//             isFromProperty,
//             hasAgentPercent,
//             setParentState,
//             ...rest
//         } = this.props;
//         const { items } = this.state;
//         const inactive = items && items.filter(x => x.DELETED === 'y') || [];
//         const active = items && items.filter(x => x.DELETED !== 'y') || [];
//         let itemsSorted = [...active, ...inactive];

//         itemsSorted = itemsSorted.map((el) => {
//             el.groupedBy = el.DELETED !== 'y' ? 'active' : 'inactive';
//             return el
//         });

//         if(this.props.onlyActive){
//             itemsSorted = itemsSorted.filter((e)=> e.IS_AGENT==='y' && e.groupedBy==='active')
//         }

//         return (
//             <Dropdown theme={theme}
//                       optionsType='team'
//                       optionKey='ARCIMEDES_ROW_ID'
//                       options={itemsSorted}
//                       value={value}
//                       valueKey={valueKey}
//                       percentKey={percentKey}
//                       label={label}
//                       percentLabel={percentLabel}
//                       disabled={!items || disabled}
//                       data={data}
//                       isFilter={isFilter}
//                       groupBy={true && !this.props.onlyActive}
//                       handleParentChange={handleParentChange}
//                       handleInputParentChange={handleInputParentChange}
//                       viewMode={viewMode}
//                       deleted={deleted}
//                       isFromProperty={isFromProperty}
//                       hasAgentPercent={hasAgentPercent}
//                       {...rest}
//             />
//         )
//     }
// }

// SelectTeam.propTypes = {
//     theme: PropTypes.oneOf(['default', 'white', 'dark']),
//     value: PropTypes.string,
//     valueKey: PropTypes.string.isRequired,
//     label: PropTypes.string,
//     percentLabel: PropTypes.string,
//     disabled: PropTypes.bool,
//     data: PropTypes.object,
//     handleParentChange: PropTypes.func.isRequired,
//     isFilter: PropTypes.bool,
//     viewMode: PropTypes.bool,
//     groupBy: PropTypes.bool,
//     deleted: PropTypes.bool,
//     isFromProperty: PropTypes.bool,
//     hasAgentPercent: PropTypes.bool,
//     handleInputParentChange: PropTypes.func,
// };

// export default SelectTeam;

//#endregion

import React from 'react';
import request from 'arcdynamic-request';
import Dropdown from "../Dropdown/Dropdown";
import PropTypes from "prop-types";
import { ApolloConsumer } from '@apollo/client';
import { GET_ALL_TEAMMEMBERS } from '../Graphql/Queries/TeamMemberQuery';
import { GET_CONTACT_TEAM_LIST_QUERY, GET_CONTACT_TEAM_BY_ARCIMEDES_ID } from '../Graphql/ContactsQueries/contactsQuery';
import { fetchData } from '../Service/graphQlService';

// A team member is considered inactive/terminated when its `deleted` flag is set.
// Terminated members are removed from the team list query, so their name would
// otherwise fail to resolve on existing properties (listing / buyside / payment).
const isInactiveMember = (member) =>
    !!member && (member.deleted === 'y' || member.deleted === '1' || member.deleted === 1);

class SelectTeam extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
        };
        this.client = null;
    }

    componentDidMount() {
        // request(arc.path.api, {
        //     service: 'arcimedes',
        //     action: 'open.datasource.table.Data.getData',
        //     params: ['code', 'TEAM', {
        //         limit: {
        //             count: 1000,
        //             offset: 0,
        //         },
        //         column: [
        //             'ARCIMEDES_ROW_ID',
        //             'FIRST_NAME',
        //             'LAST_NAME',
        //             'DELETED',
        //             'IS_AGENT',
        //         ],
        //         filter: [
        //             {
        //                 code: 'FIRST_NAME',
        //                 text: '',
        //                 type: 'notNull',
        //             },
        //             {
        //                 code: 'LAST_NAME',
        //                 text: '',
        //                 type: 'notNull',
        //             },
        //         ],
        //         filterType: 'and',
        //         order: [
        //             {
        //                 code: 'FIRST_NAME',
        //                 type: 'asc',
        //             },
        //             {
        //                 code: 'LAST_NAME',
        //                 type: 'asc',
        //             },
        //         ],
        //     }],
        // })
    //     if(this.client){
    //         const token = localStorage.getItem('authToken');
    //         this.client.query({query:GET_ALL_TEAMMEMBERS,fetchPolicy: "no-cache",
    //         context: {
    //             headers: {
    //                 authorization: `Bearer ${token}`, // Bearer token added here
    //             },
    //         }}).then(res => {
    //             let items = res.data ? res.data.getAllTeamMembers.filter(x => x.first_name && x.last_name) : false;           
    //             this.setState({items});
    //         });
    //     }
        
    // }
        this.fetchTeamList();

    }

    componentDidUpdate(prevProps) {
        // The assigned agent id can arrive/change after mount (property data loads
        // asynchronously). Re-check that the selected value is resolvable.
        if (prevProps.value !== this.props.value) {
            this.ensureSelectedResolvable();
        }
    }

    fetchTeamList() {
        if (this.client) {
          fetchData(GET_CONTACT_TEAM_LIST_QUERY, {
            type: "Team",
            sortOptions: [
              {
                field: "first_name",
                order: "asc",
              },
              {
                field: "last_name",
                order: "asc",
              },
            ],
          })
            // const token = localStorage.getItem('authToken');
            // this.client.query({query:GET_ALL_TEAMMEMBERS,fetchPolicy: "no-cache",
            // this.client.query({query:GET_CONTACT_TEAM_LIST_QUERY,variables:{type:"Team",sortOptions:[
            //     {
            //       "field": "first_name",
            //       "order": "asc"
            //     },
            //     {
            //       "field": "last_name",
            //       "order": "asc"
            //     }
            //   ]},fetchPolicy: "no-cache",
            // context: {
            //     headers: {
            //         authorization: `Bearer ${token}`, // Bearer token added here
            //     },
            // }})
            .then((res) => {
              // let items = res.data ? res.data.getAllTeamMembers.filter(x => x.first_name && x.last_name) : false;
              let items = res.data
                ? res.data.getContacts.data.filter(
                    (x) => x.first_name && x.last_name
                  )
                : false;
              this.setState({ items: items || [] }, () => this.ensureSelectedResolvable());
            });
        }
    }

    // If the currently assigned agent is not present in the fetched team list
    // (e.g. terminated/inactive, or beyond the list's page size), fetch that
    // single contact by id and inject it so its name renders. This keeps the
    // behaviour consistent for listing agents, buyside agents and payment
    // team members, all of which use this component.
    ensureSelectedResolvable() {
        const { value } = this.props;
        // Filter / active-only pickers deliberately show active members only and
        // may hold multiple comma-separated ids, so skip injection there.
        if (this.props.onlyActive || this.props.isFilter) return;
        if (value === null || value === undefined || value === '' || String(value) === '0') {
            return;
        }
        const items = Array.isArray(this.state.items) ? this.state.items : [];
        const alreadyPresent = items.some(
            (x) => String(x.arcimedes_row_id) === String(value)
        );
        if (alreadyPresent) return;

        // Guard against duplicate in-flight fetches for the same value.
        if (this._resolvingValue === String(value)) return;
        this._resolvingValue = String(value);

        fetchData(GET_CONTACT_TEAM_BY_ARCIMEDES_ID, { arcimedes_row_id: value })
            .then((res) => {
                const contact =
                    res && res.data && res.data.getContactTeamByArcId
                        ? res.data.getContactTeamByArcId.contact
                        : null;
                if (contact && contact.first_name && contact.last_name) {
                    this.setState((prev) => {
                        const prevItems = Array.isArray(prev.items) ? prev.items : [];
                        const exists = prevItems.some(
                            (x) => String(x.arcimedes_row_id) === String(contact.arcimedes_row_id)
                        );
                        if (exists) return null;
                        return { items: [...prevItems, contact] };
                    });
                }
            })
            .catch(() => {
                // Reset guard so a later prop change can retry.
                this._resolvingValue = null;
            });
    }

    render() {
        const {
            theme,
            value,
            valueKey,
            percentKey,
            label,
            percentLabel,
            disabled,
            data,
            isFilter,
            handleParentChange,
            handleInputParentChange,
            viewMode,
            deleted,
            isFromProperty,
            hasAgentPercent,
            setParentState,
            ...rest
        } = this.props;
        const items = Array.isArray(this.state.items) ? this.state.items : [];
        const active = items.filter(x => !isInactiveMember(x));
        const inactive = items.filter(x => isInactiveMember(x));
        // Active members first, inactive (terminated) grouped at the bottom.
        let itemsSorted = [...active, ...inactive].map((el) => ({
            ...el,
            groupedBy: isInactiveMember(el) ? 'inactive' : 'active',
        }));

        if(this.props.onlyActive){
            itemsSorted = itemsSorted.filter((e)=> (e.is_agent==='y' || e.is_agent==='1') && e.groupedBy==='active')
        }

        return (
            <ApolloConsumer>
                {client => {
                    if(!this.client){
                        this.client =client;
                    }
                        return(
                            <Dropdown theme={theme}
                                optionsType='team'
                                optionKey='arcimedes_row_id'
                                options={itemsSorted}
                                value={value}
                                valueKey={valueKey}
                                percentKey={percentKey}
                                label={label}
                                percentLabel={percentLabel}
                                disabled={!items || disabled}
                                data={data}
                                isFilter={isFilter}
                                groupBy={true && !this.props.onlyActive}
                                handleParentChange={handleParentChange}
                                handleInputParentChange={handleInputParentChange}
                                viewMode={viewMode}
                                deleted={deleted}
                                isFromProperty={isFromProperty}
                                hasAgentPercent={hasAgentPercent}
                                {...rest}
                            />
                        )
                }}
            </ApolloConsumer>
            
        )
    }
}

SelectTeam.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark']),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    label: PropTypes.string,
    percentLabel: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    handleParentChange: PropTypes.func.isRequired,
    isFilter: PropTypes.bool,
    viewMode: PropTypes.bool,
    groupBy: PropTypes.bool,
    deleted: PropTypes.bool,
    isFromProperty: PropTypes.bool,
    hasAgentPercent: PropTypes.bool,
    handleInputParentChange: PropTypes.func,
};

export default SelectTeam;
